<template>
  <div>
    <section class="store-list ly-list">
      <div class="section-inner">
        <div class="section-cont">
          <h2>가맹점 현황 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>PARTNERSHIP</span>&nbsp;&gt;&nbsp;
            <span>가맹점 현황 관리</span>
          </p>
          <!-- /.site-path -->
          <p class="total-post">
            전체 게시물 <span>{{ getDataTotalCount }}</span
            >개
          </p>
          <!-- /.total-post -->
          <search-input :searchHandler="onSearch" />
          <!-- /.search -->
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
              <col class="col3" />
              <col class="col4" />
              <col class="col5" />
              <col class="col6" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="check-cell">
                  <label for="" class="hidden">전체체크</label
                  ><input
                    type="checkbox"
                    @click="check()"
                    v-model="checkAllValue"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="../../../assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </th>
                <th scope="col">No.</th>
                <th scope="col">오픈일</th>
                <th scope="col">가맹점 명</th>
                <th scope="col">신규 오픈 여부</th>
                <th scope="col">등록일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in getData" v-bind:key="item.id">
                <td class="check-cell">
                  <label for="" class="hidden">해당년도체크</label
                  ><input
                    type="checkbox"
                    v-model="checkedValues"
                    :value="item.id"
                  />
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="../../../assets/image/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'StoreEdit',
                      params: { id: item.id, item: item },
                    }"
                    >{{ item.id }}</router-link
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'StoreEdit',
                      params: { id: item.id, item: item },
                    }"
                    >{{ item.open_fullyear }}</router-link
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'StoreEdit',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ item.name }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'StoreEdit',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ item.is_newopened == 1 ? "O" : "X" }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'StoreEdit',
                      params: { id: item.id, item: item },
                    }"
                  >
                    {{ $moment(item.created_dttm).format("YYYY.MM.DD") }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- /.table-->
          <div class="page">
            <paginate
              :pageCount="totalPages"
              :pageRange="10"
              :clickHandler="handlePageSelected"
            ></paginate>
          </div>
          <!--./paginate-->
          <div class="btn-wrap">
            <button class="btn-icon-del" @click="onConfirmDelete">
              <img src="../../../assets/image/btn-del.png" alt="delete icon" />
              <span>선택삭제</span>
            </button>
            <router-link :to="{ name: 'StoreCreate' }" class="btn-blue"
              >등록</router-link
            >
          </div>
          <!-- /.btn-wrap -->
        </div>
        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import Paginate from "../../Paginate.vue";
import { mapGetters } from "vuex";
import SearchInput from "../../SearchInput.vue";

export default {
  components: { AppFooter, Paginate, SearchInput },
  name: "StoreList",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getData: "partnership/getStoreOpenConditionList",
      getDataTotalCount: "partnership/getStoreOpenConditionTotalCount",
    }),
  },
  created() {
    this.checkedValues = [];
    this.$store.dispatch("partnership/req_store_open_condition_list", {
      page: 1,
      size: this.PAGE_SIZE,
    });
  },
  methods: {
    handlePageSelected(page) {
      console.log("handlePageSelected => ", page);
      this.$store.dispatch("partnership/req_store_open_condition_list", {
        page: page,
        size: this.PAGE_SIZE,
        searchtext: this.searchtext,
      });
    },
    onSearch(text) {
      this.searchtext = text ; 
      this.$store.dispatch("partnership/req_store_open_condition_list", {
        page: 1,
        size: this.PAGE_SIZE,
        searchtext: this.searchtext,
      });
    },
    onSubmitDelete()  {
      console.log("onSubmitDelete ==> ", this.checkedValues);
      if (this.checkedValues.length > 0) {        

        this.$store.dispatch("partnership/req_remove_store_open_condition_list", {
          idarr: this.checkedValues,
          
        }).then( ( ) => {
          this.checkedValues = [];
        });

      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/helpers/variables";
@import "../../../assets/scss/helpers/mixins";
@import "../../../assets/scss/base/typhography";

.store-list {
  .section-inner {
    .section-cont {
      table {
        colgroup {
          .col1 {
            width: 64px;
          }
          .col2 {
            width: 91px;
          }
          .col3 {
            width: 180px;
          }
          .col4 {
            width: calc(100% - 64px - 91px - 180px - 170px - 180px);
          }
          .col5 {
            width: 170px;
          }
          .col6 {
            width: 180px;
          }
        }
      }
    }
  }
}
</style>
